export enum BadgeType {
    CheckInContacts = 'CheckInContacts',
    MaintenanceSchedule = 'MaintenanceSchedule',
    VehicleSettings = 'VehicleSettings',
}
